import DualRange from "./DualRange";
import "./../styles/PriceSlider.css";

export const PRICE_STEPS = Array.from({ length: 21 }, (_, i) => i * 50);

export const fmtPrice = (v) => {
  const last = PRICE_STEPS[PRICE_STEPS.length - 1];
  return v === last ? `$${last}+` : `$${v}`;
};

const PriceSlider = ({ value, onChange }) => {
  const [minIdx, maxIdx] = value;

  const showLeftValue = minIdx !== 0;
  const showRightValue = maxIdx !== PRICE_STEPS.length - 1;
  return (
    <div className="flex items-center gap-3 md:gap-4 shrink-0 price-slider">
      <div className="flex items-center gap-3 md:gap-4 shrink-0">

        <div className="w-28 sm:w-44 md:w-52 lg:w-60 ml-[10px] mb-[10px]">
          <div className="flex justify-between mb-2 text-sm">
            <span className="text-gray-800">
              {showLeftValue ? fmtPrice(PRICE_STEPS[minIdx]) : "$0"}
            </span>
            <span className="text-gray-800">
              {showRightValue ? fmtPrice(PRICE_STEPS[maxIdx]) : fmtPrice(PRICE_STEPS[PRICE_STEPS.length - 1])}
            </span>
          </div>

          <DualRange
            min={0}
            max={PRICE_STEPS.length - 1}
            step={1}
            value={[minIdx, maxIdx]}
            onChange={onChange}
            format={(i) => fmtPrice(PRICE_STEPS[i])}
            showTooltips={false}
            className="relative"
          />
        </div>
      </div>
    </div>
  );
};

export default PriceSlider;
